import {
  RESET_INTERVENTION_MODULE,
  SET_EXEMPTION_END_DATE,
  SET_EXEMPTION_END_DISABLED,
  SET_EXEMPTION_ID,
  SET_EXEMPTION_REASON,
  SET_EXEMPTION_START_DATE,
  SET_EXEMPTION_START_DISABLED,
  SET_INTERVENTION_STUDENT,
  SET_INTERVENTION_STUDENTS,
  SET_DRAWER_COMPONENT_TITLE
} from '../store/mutation-types'
import { IS_STUDENT } from '../store/getter-types'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import {components, componentTitles} from '../store/modules/rightDrawer'
import moment from 'moment-es6'
import { DELETE_EXEMPTION } from '../store/action-types'
import RightDrawer from './RightDrawer'

const EditExemption = {
  mixins: [RightDrawer],
  methods: {
    ...mapMutations({
      setExemptionId: SET_EXEMPTION_ID,
      resetInterventionModule: RESET_INTERVENTION_MODULE,
      editExemptionReason: SET_EXEMPTION_REASON,
      setExemptionStudents: SET_INTERVENTION_STUDENTS,
      setExemptionStudentId: SET_INTERVENTION_STUDENT,
      setExemptionStartDate: SET_EXEMPTION_START_DATE,
      setExemptionEndDate: SET_EXEMPTION_END_DATE,
      setExemptionStartDisabled: SET_EXEMPTION_START_DISABLED,
      setExemptionEndDisabled: SET_EXEMPTION_END_DISABLED,
      setDrawerComponentTitle: SET_DRAWER_COMPONENT_TITLE
    }),
    ...mapActions({
      deleteExemption: DELETE_EXEMPTION
    }),
    getStartAndEndDate () {
      const startDate = moment(this.exemption.startDate)
      const endDate = moment(this.exemption.endDate)
      return {startDate, endDate}
    },
    editExemption () {
      this.setDrawerComponent(components.CREATE_EXEMPTION)
      this.setDrawerComponentTitle(componentTitles.EDIT_EXEMPTION)
      this.setDrawerState(true)
      const {startDate, endDate} = this.getStartAndEndDate()
      this.resetInterventionModule()
      this.editExemptionReason(this.exemption.exemptionReason.id)
      this.setExemptionStudents([{
        firstName: this.exemption.student.firstName,
        lastName: this.exemption.student.lastName,
        studentIdentifier: this.exemption.student.studentIdentifier,
        displayId: this.exemption.student.displayId,
        id: this.exemption.student.id
      }])
      this.setExemptionStudentId(this.exemption.student.id)
      this.setExemptionStartDate(startDate.format('YYYY-MM-DD'))
      this.setExemptionEndDate(endDate.format('YYYY-MM-DD'))
      this.setExemptionId(this.exemption.id)
    }
  },
  computed: {
    shouldShowMenu () {
      return (!this.isStudent)
    },
    shouldShowDelete () {
      const now = moment()
      const {startDate} = this.getStartAndEndDate()
      return !now.isAfter(startDate, 'd') // Hasn't started
    },
    ...mapGetters({
      isStudent: IS_STUDENT
    })
  }
}

export default EditExemption



// WEBPACK FOOTER //
// ./src/mixins/EditExemption.js